module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-10-16de7119f190af6b94903d4b0586420e.png";